<template>
	<div
		class="d-flex flex-column justify-content-between lap-welcomestep-height"
	>
		<section class="onboarding-top-content invisible-scroll">
			<section class="w-521px">
				<section
					class="obm-chat-container mt-36px d-flex justify-content-center"
				>
					<!-- Stage 1: Grey bubble with avatar -->
					<transition name="chat-pop">
						<div
							v-if="animationStage >= 1"
							class="obm-hire3x-chat-bubble w-80 position-relative d-flex justify-content-between p-0 mob-w-100"
						>
							<span class="p1624-bubble">
								Awesome! Lastly What brings you to Hire3x?
							</span>
							<img
								src="../../../assets/newonboarding/chatbubble1-img.svg"
								class="first-bubble-img-pos"
								alt=""
							/>
						</div>
					</transition>
				</section>

				<!-- Stage 2: Goal cards + actions -->
				<transition name="chat-pop">
					<div v-if="animationStage >= 2">
						<section class="goal-grid mt-32px">
							<div
								v-for="goal in goals"
								:key="goal.id"
								class="goal-card"
								:class="{ active: selectedGoals.includes(goal.id) }"
								@click="toggleGoal(goal.id)"
							>
								<div class="goal-check">
									<img
										:src="
											selectedGoals.includes(goal.id) ? greenTick : whiteCircle
										"
										alt=""
									/>
								</div>
								<img :src="goal.image" class="goal-icon" :alt="goal.label" />
								<p
									class="fs-14 fam-mont m-0 text-center"
									:class="
										selectedGoals.includes(goal.id)
											? 'fw-B color-1F1F1F'
											: 'fw-LM text-white'
									"
									v-html="goal.label"
								></p>
							</div>
						</section>

						<!-- <div class="d-flex justify-content-center mt-32px">
						<span
							class="fs-16 fw-M fam-inter text-white underline"
							@click="$emit('explore')"
							>Go Explore Hire3x!</span
						>
					</div> -->
					</div>
				</transition>
			</section>
		</section>
		<section
			class="onboarding-top-content onboarding-bottom-content mob-pt-25px"
		>
			<section class="w-345px">
				<transition name="chat-pop">
					<div
						v-if="buttonsVisible"
						class="d-flex align-items-center justify-content-between gap-12px mt-30px pb-36px mt-mob-0"
					>
						<button class="obm-back-btn" @click="handleBack">Go back</button>
						<button
							class="obm-continue-btn w-150px"
							:disabled="isSubmitting"
							@click="handleContinue"
						>
							{{ selectedGoals.length === 0 ? "Explore Hire3x" : "Continue" }}
						</button>
					</div>
				</transition>
			</section>
		</section>
	</div>
</template>

<script>
import {
	postCandidateOnboard,
	getCandidateOnboard,
	updateCandidateOnboard,
	getCandInfo,
	getProfileCompletion,
	userInfo,
	getCandidatePrimaryProfile,
} from "@/utils/apiFunctions";

export default {
	emits: ["back", "next", "explore"],

	data() {
		return {
			animationStage: 0,
			buttonsVisible: false,
			isSubmitting: false,
			selectedGoals: [],
			whiteCircle: require("@/assets/newonboarding/whitecircle.svg"),
			greenTick: require("@/assets/newonboarding/greentick.svg"),
			goals: [
				{
					id: "upskill",
					label: "Upskill with<br/>Courses",
					image: require("@/assets/newonboarding/upskillvthcourse.svg"),
				},
				{
					id: "assessment",
					label: "Take<br/>Assessments",
					image: require("@/assets/newonboarding/takeasmnt.svg"),
				},
				{
					id: "jobs",
					label: "Search & Apply<br/>for Jobs",
					image: require("@/assets/newonboarding/searchnapplyjobs.svg"),
				},
				{
					id: "interviews",
					label: "Prepare for<br/>Interviews",
					image: require("@/assets/newonboarding/prepareinterview.svg"),
				},
				{
					id: "instructor",
					label: "Become an<br/>Instructor",
					image: require("@/assets/newonboarding/becomeinstructor.svg"),
				},
				{
					id: "panelist",
					label: "Join as a<br/>Panelist",
					image: require("@/assets/newonboarding/joinpanelist.svg"),
				},
			],
		};
	},

	async mounted() {
		await this.playAnimation();
	},

	methods: {
		wait(ms) {
			return new Promise((resolve) => setTimeout(resolve, ms));
		},

		async playAnimation() {
			await this.wait(400);
			this.animationStage = 1;
			await this.wait(800);
			this.animationStage = 2;
			await this.wait(400);
			this.buttonsVisible = true;
		},

		async handleBack() {
			// Call API once here. The response (prefill data + level) is forwarded
			// to the parent so DetailsStep can be pre-filled without calling the
			// API a second time in its own mounted().
			let prefillData = null;
			try {
				const response = await getCandidateOnboard({ step: "skills" });
				prefillData = response?.data?.data ?? null;
			} catch (err) {
				console.error("Error fetching onboarding data on back:", err);
			}
			this.$emit("back", prefillData);
		},

		toggleGoal(id) {
			const idx = this.selectedGoals.indexOf(id);
			if (idx === -1) {
				this.selectedGoals.push(id);
			} else {
				this.selectedGoals.splice(idx, 1);
			}
		},

		// async fetchAndStoreUserParser() {
		// 	// 1. getCandInfo → candidateVUEX/setCandidateInfo (getcandidateInfo getter)
		// 	let candidateData = null;
		// 	try {
		// 		const res = await getCandInfo();
		// 		candidateData = res?.data?.data ?? res?.data ?? null;
		// 		if (candidateData) {
		// 			this.$store.commit("candidateVUEX/setCandidateInfo", candidateData);
		// 		}
		// 	} catch (err) {
		// 		console.error("[GoalStep] getCandInfo failed:", err);
		// 	}

		// 	// 2. getProfileCompletion → candidateVUEX/updateCandidateProgressPrimary (getCandProgressRespPrimary getter)
		// 	if (candidateData?._id) {
		// 		try {
		// 			const respData = await getProfileCompletion(candidateData._id);
		// 			const candProgressPrimaryResp = respData.data.data;
		// 			this.$store.commit(
		// 				"candidateVUEX/updateCandidateProgressPrimary",
		// 				candProgressPrimaryResp
		// 			);
		// 			console.log(
		// 				"[GoalStep] updateCandidateProgressPrimary:",
		// 				candProgressPrimaryResp
		// 			);
		// 		} catch (err) {
		// 			console.error("[GoalStep] getProfileCompletion failed:", err);
		// 		}
		// 	}

		// 	// 3. userInfo (GET /can/register) → userVUEX/setUserInfo (getUserInfo getter)
		// 	try {
		// 		const registerRes = await userInfo();
		// 		if (registerRes?.status === 200) {
		// 			this.$store.commit("userVUEX/setUserInfo", registerRes.data.data);
		// 		}
		// 	} catch (err) {
		// 		console.error("[GoalStep] userInfo (register GET) failed:", err);
		// 	}

		// 	// 4. getCandidatePrimaryProfile → candidateVUEX/setPrimaryProfile (getPrimaryCandidateInfo getter)
		// 	try {
		// 		const primaryRes = await getCandidatePrimaryProfile();
		// 		if (primaryRes?.status === 200) {
		// 			this.$store.commit(
		// 				"candidateVUEX/setPrimaryProfile",
		// 				primaryRes.data.data
		// 			);
		// 			console.log("[GoalStep] setPrimaryProfile:", primaryRes.data.data);
		// 		}
		// 	} catch (err) {
		// 		console.error("[GoalStep] getCandidatePrimaryProfile failed:", err);
		// 	}
		// },

		async handleContinue() {
			if (this.isSubmitting) return;
			this.$store.commit("userVUEX/setIsFirstTimeUser", true);
			// "Explore Hire3x" path — no goals selected
			if (this.selectedGoals.length === 0) {
				this.isSubmitting = true;
				try {
					await updateCandidateOnboard({ action: "skipGoals" });
				} catch (err) {
					console.error(
						"[GoalStep] updateCandidateOnboard skipGoals failed:",
						err
					);
				}
				try {
					// await this.fetchAndStoreUserParser();
					await this.$store.dispatch("userVUEX/fetchPostLoginData", true);
				} finally {
					this.isSubmitting = false;
				}
				const fromTraining =
					this.$route && this.$route.query && this.$route.query.fromTraining;
				const returnUrl =
					this.$route && this.$route.query && this.$route.query.returnUrl;
				this.$store.commit("candidateVUEX/setOnboardingActive", false);
				if (fromTraining && returnUrl) {
					window.location.href = decodeURIComponent(returnUrl);
					return;
				}
				this.$emit("explore");
				return;
			}

			// "Continue" path — goals selected
			this.isSubmitting = true;
			try {
				const payload = {
					step: "goals",
					goals: [...this.selectedGoals],
				};
				console.log("[GoalStep] goals payload:", payload);
				const response = await postCandidateOnboard(payload);
				console.log("[GoalStep] goals response:", response);

				// After saving goals, fetch fresh user-parser data and store in Vuex
				// await this.fetchAndStoreUserParser();
				await this.$store.dispatch("userVUEX/fetchPostLoginData", true);
			} catch (err) {
				console.error("[GoalStep] Goals onboarding error:", err);
			} finally {
				this.isSubmitting = false;
			}
			const fromTraining =
				this.$route && this.$route.query && this.$route.query.fromTraining;
			const returnUrl =
				this.$route && this.$route.query && this.$route.query.returnUrl;
			this.$store.commit("candidateVUEX/setOnboardingActive", false);
			if (fromTraining && returnUrl) {
				window.location.href = decodeURIComponent(returnUrl);
				return;
			}
			this.$emit("next");
		},
	},
};
</script>

<style scoped>
.first-bubble-img-pos {
	z-index: 2000;
}

/* ── Goal grid ── */
.goal-grid {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 16px;
}

.goal-card {
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	padding: 16px;
	width: 163px;
	height: 140px;
	background: rgba(246, 246, 246, 0.2);
	border: 1px solid rgba(226, 232, 240, 0.1);
	box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
	border-radius: 24px;
	gap: 8px;
	transition: background 0.25s ease, border-color 0.25s ease,
		box-shadow 0.25s ease, transform 0.15s ease;
}

.goal-card:active {
	transform: scale(0.96);
}

.goal-card.active {
	background: linear-gradient(0deg, rgba(0, 128, 0, 0.2), rgba(0, 128, 0, 0.2)),
		#ffffff;
	border: 2px solid #008000;
	box-shadow: 0px 0px 80px rgba(0, 0, 0, 0.04);
}
.goal-check {
	position: absolute;
	top: 8px;
	right: 8px;
}

/* ── Buttons ── */
.obm-back-btn {
	padding: 12px 24px;
	width: 141.82px;
	background: rgba(0, 0, 0, 0.004);
	border: 0.5px solid #4a7eff;
	border-radius: 40px;
	font-family: "Inter", sans-serif;
	font-weight: 600;
	font-size: 14px;
	color: #ffffff;
	cursor: pointer;
	height: 49px;
}

.obm-continue-btn {
	padding: 14px 24px;
	width: 141.82px;
	background: #4a7eff;
	border: 0.5px solid rgba(239, 239, 239, 0.14);
	border-radius: 40px;
	color: #ffffff;
	font-family: "Inter", sans-serif;
	font-size: 14px;
	font-weight: 600;
	cursor: pointer;
	height: 49px;
}

.obm-continue-btn:disabled {
	opacity: 0.45;
	cursor: not-allowed;
}

/* ── Animation ── */
.chat-pop-enter-active {
	transition: opacity 0.35s ease, transform 0.35s ease;
}

.chat-pop-leave-active {
	transition: opacity 0.2s ease;
}

.chat-pop-enter,
.chat-pop-leave-to {
	opacity: 0;
	transform: translateY(12px) scale(0.96);
}
.color-1F1F1F {
	color: #1f1f1f;
}
.w-80 {
	width: 80%;
}
.laptop-goal-btns-margins {
	margin-left: 88px;
	margin-right: 88px;
}
@media (max-width: 1028px) {
	.goal-grid {
		grid-template-columns: repeat(2, 1fr);
	}
	.goal-card {
		width: unset;
	}
	.laptop-goal-btns-margins {
		margin-left: 0;
		margin-right: 0;
	}
}
</style>
